import Vue from 'vue'
import {
    Tooltip,
    Button,
    Tag,
    Container,
    Header,
    Footer,
    Aside,
    Main,
    Menu,
    MenuItem,
    Select,
    Option,
    Input,
    InputNumber,
    Pagination,
    Tabs,
    TabPane,
    Dialog,
    Radio,
    RadioGroup,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Col,
    Row,
    Message,
    MessageBox,
    Popover,
    Carousel,
    CarouselItem,
    Card,
    Avatar,
    Image
} from 'element-ui';

Vue.use(Button);
Vue.use(Tag);
Vue.use(Container);
Vue.use(Header);
Vue.use(Footer);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Pagination);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Dialog);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Col);
Vue.use(Row);
Vue.use(Popover);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Card);
Vue.use(Avatar);
Vue.use(Image);
Vue.use(Tooltip);
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message; // 消息提示